<p-toast></p-toast>
<div class="card" *ngIf="false">
    <div class="msg">
        <p>As instructed by HAREDA department generation of challans has been stopped till further notification.</p>
    </div>

</div>
<div class="solar-challan-container">
    <div class="card" id="select_app_solor_card">
        <div class="mt-3">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-6">
                    <h4 class="mt-3 ">{{'SOLAR_CHALLAN'| translate}}</h4>
                </div>

                <div class="field col-12 md:col-6 grid">
                    <label class="mx-4" htmlFor="appId"><b>{{'SELECT_APPLICATION_ID'| translate}}</b></label>
                    <p-dropdown [options]="farmerAppDetails" [(ngModel)]="selectedFarmerDeatils"
                        (onChange)="onSelectAppId()" placeholder="{{'SELECT_APPLICATION_ID'| translate}}"></p-dropdown>
                </div>
            </div>
        </div>
    </div>


    <div class="card" reflow="true" *ngIf="solarPumpDetail != null">
        <h5>{{'SOLAR_PUMP_DETAIL'| translate}}</h5>
        <!-- <div class="p-fluid p-formgrid grid"> -->
        <form [formGroup]="solarApplicatonForm" class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-4">
                <label htmlFor="waterSourceType">{{'LAND_ID_'| translate}}</label>
                <p-dropdown [options]="landIDList" formControlName="landId"
                    placeholder="{{'SELECT_LAND_IDS'| translate}}" (onChange)="onSolarLandIdSelected($event)"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedSolarApplicatonFrom && solarApplicatonFormControls.landId.errors || solarApplicatonFormControls.landId.touched && solarApplicatonFormControls.landId.errors}"></p-dropdown>
                <div *ngIf="isSubmittedSolarApplicatonFrom && solarApplicatonFormControls.landId.errors || solarApplicatonFormControls.landId.touched && solarApplicatonFormControls.landId.errors"
                    class="invalid-feedback">
                    <div *ngIf="solarApplicatonFormControls.landId.errors.required">
                        {{'LAND_ID_IS_REQUIRED'| translate}}
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label htmlFor="waterSourceType">{{'PUMP_CONTROLLER_TYPE'| translate}}</label>
                <div class="formgroup-inline">
                    <div class="field">
                        <div class="field-radiobutton mb-0">
                            <p-radioButton formControlName="controlType" value="Normal" id="IsSubsidyAvailabeYes"
                                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                            <label for="IsSubsidyAvailabeYes">{{'NORMAL_SOLAR_PUMP_COMTROLLER'| translate}}</label>
                        </div>
                    </div>
                    <div class="field">
                        <div class="field-radiobutton mb-0">
                            <p-radioButton formControlName="controlType" value="Universial" id="IsSubsidyAvailabeNo"
                                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                            <label for="IsSubsidyAvailabeNo">{{'UNIVERSAL_SOLAR_PUMP_CONTROLLER'| translate}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label htmlFor="waterSourceType">{{'PUMP_TYPE'| translate}}</label>
                <div class="formgroup-inline">
                    <div class="field">
                        <div class="field-radiobutton mb-0">
                            <p-radioButton formControlName="pump" value="Surface" id="IsSubsidyAvailabeYes"
                                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                            <label for="IsSubsidyAvailabeYes">{{'SURFACE_PUMP'| translate}}</label>
                        </div>
                    </div>
                    <div class="field">
                        <div class="field-radiobutton mb-0">
                            <p-radioButton formControlName="pump" value="Submersible" id="IsSubsidyAvailabeNo"
                                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                            <label for="IsSubsidyAvailabeNo">{{'SUBMERSIBLE_PUMP'| translate}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label htmlFor="waterSourceType">{{'SOLAR_PUMP_CATEGORY'| translate}}</label>
                <div class="formgroup-inline">
                    <div class="field">
                        <div class="field-radiobutton mb-0">
                            <p-radioButton formControlName="pumpType" value="AC" id="IsSubsidyAvailabeYes"
                                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                            <label for="IsSubsidyAvailabeYes">{{'AC'| translate}}</label>
                        </div>
                    </div>
                    <div class="field">
                        <div class="field-radiobutton mb-0">
                            <p-radioButton formControlName="pumpType" value="DC" id="IsSubsidyAvailabeNo"
                                (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                            <label for="IsSubsidyAvailabeNo">{{'DC'| translate}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label htmlFor="waterSourceType">{{'CAPACITY_OF_SOLAR_PUMP'| translate}} </label>
                <p-dropdown [options]="pumpCapacityList" formControlName="pumpCapacity" optionLabel="Pump_Capacity"
                    optionValue="Pump_Capacity" (onChange)="onCapacityOfPumpSelected($event)"
                    placeholder="{{'SELECT_A_CAPACITY'| translate}}"></p-dropdown>
            </div>
            <div class="field col-12 md:col-4" *ngIf="primarySolarVendorList.length && pumpCapacityList.length">
                <label htmlFor="waterSourceType">{{'PRIMARY_VENDOR'| translate}} </label>
                <p-dropdown [options]="primarySolarVendorList" formControlName="primaryVendor"
                    optionLabel="Primary_Vendor" optionValue="Primary_Vendor" placeholder="{{'SELECT_A_PRIMARY_VENDOR' | translate}}"
                    (onChange)="onPrimarySolarVendorChange($event)"
                    [(ngModel)]="selectedPrimarySolarVendor"></p-dropdown>
            </div>
            <div class="field col-12 md:col-4" *ngIf="primarySolarVendorList.length && secondarySolarVendorList.length && pumpCapacityList.length">
                <label htmlFor="waterSourceType">{{'SECONDARY_VENDOR'| translate}} </label>
                <p-dropdown [options]="secondarySolarVendorList" formControlName="secondaryVendor"
                    optionLabel="Secondary_Vendor" optionValue="Secondary_Vendor"
                    [(ngModel)]="selectedSecondarySolarVendor" placeholder="{{'SELECT_A_SECONDARY_VENDOR' | translate}}"
                    (onChange)="onSecondarySolarVendorChange($event)"></p-dropdown>
            </div>
            <div class="field col-12 md:col-4">
                <label htmlFor="farmerName">{{'FARMER_SHARE_TOTAL'| translate}}</label>
                <input formControlName="farmerShare" readonly pInputText id="farmerName" type="text" />
            </div>
        </form>
        <button (click)="onSolarFormUpdate()" pButton pRipple type="button" label="{{'UPDATE' | translate}}"
            class="p-button-success mr-2 mb-2 mt-2" [disabled]="!solarApplicatonForm.valid || isUpdateButtonDisabled"></button>
    </div>


    <div *ngIf="dataRecieved" class="card">
        <div class="p-fluid p-formgrid grid card" id="printableArea_solar">
            <!-- bank copy -->
            <div class="field col-12 md:col-6" reflow="true">
                <div class="flex justify-content-start mb-2">{{ currentDate | date : 'medium'}}</div>
                <div class="consent-form border">
                    <div class="print border bold" style="margin-top: 1px; text-align: center; ">
                        <div class="flex justify-content-center">
                            <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="40"
                                class="mr-2">
                        </div>
                        <div class="mt-3 headings">
                            <strong>
                                {{'MICADA'| translate}}
                            </strong><br>
                            <strong>
                                {{'HARYANA'| translate}} </strong><br>

                            <strong>
                                {{'FINANCIAL_YEAR'| translate}}{{' '}}{{challanData?.finYear ? challanData?.finYear : '2022-23'}}
                            </strong>
                        </div>
                    </div>
                    <div class="flex justify-content-center mt-1 subheading">
                        <p>{{'CHALLAN_FOR_PAYMENT_OF_DUE_DATE'| translate}}</p>
                    </div>

                    <!-- personal details start -->
                    <ng-container>
                        <!-- <div class="print border bold">Personal Details</div> -->
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'DEPARTMENT_NAME'| translate}}:</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.DepartmentName }}</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'SERVICE_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.ServiceName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.Name }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'MICADA_APPLICATION_ID'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.AppID }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICATION_SARAIL_ID'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.ApplicantSarailId }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_FATHER_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.FatherName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_ADDRESS'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.Address }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_MOBILE_NO'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.Mobile }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'DISTRICT_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.District }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'TYPE_OF_PUMP'| translate}}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.PumpType }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'PRIMARY_VENDOR'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.PrimaryVendor }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'SECONDARY_VENDOR'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.SecondaryVendor }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED'| translate}}:

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.FarmerShare }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'IDBI_ACCOUNT_NUMBER'| translate}}:

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.IDBIBankAccNo }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'IFSC_CODE_FOR_NEFT/RTGS_TRANSFER'| translate}}:


                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.IFCSForTransfer }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'ACCOUNT_HOLDER_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.AccHolderName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'DATE_OF_CHALLAN'| translate}}:

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.DateOfChallan }}</p>
                                    </td>
                                </tr>

                            </table>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="flex justify-content-center mt-1 subheading">
                            <p>{{'FOR_BANK_USE'| translate}}</p>
                        </div>
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'TRANSACTION_NUMBER'| translate}}

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12"></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'TRANSACTION_DATE_SIGN_STAMP'| translate}}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12"></p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="flex justify-content-center mt-1 subheading">
                            <p>{{'INSTRUCTIONS_FOR_FARMER'| translate}}</p>
                        </div>
                        <ol class="note pr-2" type="1">
                            <li>{{'INSTRUCTION_FOR_FARMER_DATA'| translate}}
                            </li>
                        </ol>
                    </ng-container>


                </div>
            </div>
            <!-- bank copy end -->

            <!-- customer copy -->
            <div class="field col-12 md:col-6" reflow="true">
                <div class="flex justify-content-start mb-2">{{ currentDate | date : 'medium'}}</div>
                <div class="consent-form border">
                    <div class="print border bold" style="margin-top: 1px; text-align: center; ">
                        <div class="flex justify-content-center">
                            <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="40"
                                class="mr-2">
                        </div>
                        <div class="mt-3 headings">
                            <strong>
                                {{'MICADA'| translate}}
                            </strong><br>
                            <strong>
                                {{'HARYANA'| translate}} </strong><br>

                            <strong>
                                {{'FINANCIAL_YEAR'| translate}}{{' '}}{{challanData?.finYear ? challanData?.finYear : '2022-23'}}
                            </strong>
                        </div>
                    </div>
                    <div class="flex justify-content-center mt-1 subheading">
                        <p>{{'CHALLAN_PAYMENT_DUE_AMOUNT_CUSTOMER_COPY'| translate}}</p>
                    </div>

                    <!-- personal details start -->
                    <ng-container>
                        <!-- <div class="print border bold">Personal Details</div> -->
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'DEPARTMENT_NAME'| translate}}:</p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.DepartmentName }}</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'SERVICE_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.ServiceName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.Name }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'MICADA_APPLICATION_ID'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.AppID }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICATION_SARAIL_ID'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.ApplicantSarailId }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_FATHER_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.FatherName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_ADDRESS'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.Address }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'APPLICANT_MOBILE_NO'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.Mobile }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'DISTRICT_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.District }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'TYPE_OF_PUMP'| translate}}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.PumpType }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'PRIMARY_VENDOR'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.PrimaryVendor }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'SECONDARY_VENDOR'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.SecondaryVendor }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED'| translate}}:

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.FarmerShare }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'IDBI_ACCOUNT_NUMBER'| translate}}:

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.IDBIBankAccNo }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'IFSC_CODE_FOR_NEFT/RTGS_TRANSFER'| translate}}:


                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.IFCSForTransfer }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'ACCOUNT_HOLDER_NAME'| translate}}:
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.AccHolderName }}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'DATE_OF_CHALLAN'| translate}}:

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12">{{ challanData?.DateOfChallan }}</p>
                                    </td>
                                </tr>

                            </table>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="flex justify-content-center mt-1 subheading">
                            <p>{{'FOR_BANK_USE'| translate}}</p>
                        </div>
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'TRANSACTION_NUMBER'| translate}}

                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12"></p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p class="bold col-12">{{'TRANSACTION_DATE_SIGN_STAMP'| translate}}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="col-12"></p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-container>

                    <ng-container>
                        <div class="flex justify-content-center mt-1 subheading">
                            <p>{{'INSTRUCTIONS_FOR_FARMER'| translate}}</p>
                        </div>
                        <ol class="note pr-2" type="1">
                            <li>{{'INSTRUCTION_FOR_FARMER_DATA'| translate}}
                            </li>
                        </ol>
                    </ng-container>


                </div>
            </div>
            <!-- customer copy end -->


        </div>
        <div class="flex justify-content-around mt-5">
            <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT'| translate}}"
                (click)="onPrint('printableArea_solar')"></button>
        </div>
    </div>
</div>